export default __webpack_public_path__ + "static/media/checktastic.e9e592c3.jpg";